import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCampaigns, pauseCampaign, deleteCampaign } from '../api';
import { useAuth } from '../auth';
const ICONS={'IT & Software':'💻','Healthcare':'🏥','Logistics':'🚚','Retail':'🛒','Education':'📚','Manufacturing':'🏭','Finance':'🏦','Real Estate':'🏠','Food & Agri':'🌾'};
export default function Campaigns({ showToast }) {
  const { can } = useAuth();
  const [camps,setC]=useState([]);const [load,setL]=useState(true);const nav=useNavigate();
  const fetch=()=>getCampaigns().then(r=>setC(r.data)).finally(()=>setL(false));
  useEffect(()=>{fetch();},[]);
  const pause=async(id,e)=>{e.stopPropagation();await pauseCampaign(id);fetch();};
  const handleDelete=async(id,e)=>{
    e.stopPropagation();
    if(!window.confirm('Delete this campaign? Leads in it will be unassigned, not deleted.'))return;
    await deleteCampaign(id);
    showToast&&showToast('Campaign deleted');
    fetch();
  };
  if(load)return<div className="loading-center"><div className="spinner spinner-lg"/></div>;
  return(<>
    {camps.length===0&&<div className="empty-state"><div className="empty-icon">🚀</div><div className="empty-title">No campaigns yet</div><div className="empty-desc">Create a campaign to start sending bulk outreach emails</div><button className="btn btn-primary" onClick={()=>nav('/campaigns/new')}>+ New campaign</button></div>}
    {camps.map(c=>(
      <div key={c.id} className="campaign-card">
        <div className="campaign-icon" style={{background:'var(--blue-bg)'}}>{ICONS[c.sector]||'📊'}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:3}}>
            <span style={{fontWeight:700,fontSize:14}}>{c.name}</span>
            <span className={`pill ${c.status==='active'?'s-active':'s-paused'}`}>{c.status}</span>
          </div>
          <div style={{fontSize:12,color:'var(--text-2)',marginBottom:5}}>
            {c.leads_count} leads · {c.replied_count||0} replied · {c.email_count||0} emails sent
          </div>
          <div className="progress-bar">
            <div className="progress-fill" style={{width:`${c.leads_count?Math.min((c.email_count||0)/c.leads_count*100,100):0}%`}}/>
          </div>
        </div>
        <div style={{textAlign:'right',flexShrink:0,marginRight:8}}>
          <div style={{fontSize:20,fontWeight:700}}>{c.reply_rate||0}%</div>
          <div style={{fontSize:11,color:'var(--text-2)'}}>reply rate</div>
        </div>
        <button className="btn btn-sm" onClick={e=>pause(c.id,e)}>{c.status==='active'?'Pause':'Resume'}</button>
        {can('campaigns_delete') && <button className="btn btn-danger btn-sm" onClick={e=>handleDelete(c.id,e)}>✕</button>}
      </div>
    ))}
  </>);
}
